import React from 'react';
import {
    Marker,
    Polygon,
    Polyline,
    Popup,
    useMap
} from "react-leaflet";
import L from 'leaflet';
import { menu2icon } from './config';
import m_pin_blue from '../../../assets/img/marker/m_pin_blue.png';
// eslint-disable-next-line

const Component = ({spot, latitude, longitude, menu, draggable=false, option}) => {
    // eslint-disable-next-line

    let icon = null

    if (option) {
      
      if (menu2icon[option.id]) {
        // 汎用的なicon取得(option.idから取得)
        icon = menu2icon[option.id]
        
      } else if (option.id == "sekisetusin_6_10") {
        // 06: 道路カメラ・冬季道路情報のアイコン切り替え
        icon = menu2icon[spot["種別"]]
        
      } else if (option.id == "dorokisei_3") {

        // 03: 事前通行規制区間
        if (["1020", "1038"].includes(spot['rosenno'])) {
          // ※「海田大橋広島はつかいち大橋の通行規制区間」のアイコンは路線番号（rosenno）が臨港道路（"1020" or "1038"）の場合、臨港道路の共通アイコンを表示する。
          icon = menu2icon["original_kaita_bridge"]
        } else {
          icon = menu2icon[spot.icon] ? menu2icon[spot.icon] : m_pin_blue
        }
        
      } else if (["dorokisei_1", "dorokisei_2"].includes(option.id)) {
        // 01 本日の規制, 02 今後の規制
        icon = menu2icon[spot.icon]

      } else {
        icon = m_pin_blue
      }
      
    } else {
  
      icon = menu2icon[menu] ? menu2icon[menu] : m_pin_blue
    }
    
    const iconUrl = new L.Icon({
        iconUrl: icon,
        iconRetinaUrl: icon,
        iconSize: [35, 35],
        iconAnchor: [17, 23],
        popupAnchor: [0, -50]
    });
    const map = useMap()
    const bounds = map.getBounds()
    const minlat = bounds._southWest.lat
    const maxlat = bounds._northEast.lat
    const minlng = bounds._southWest.lng
    const maxlng = bounds._northEast.lng

    /**
     * スポットのポップアップ内の表示情報を出力する。
     * @param menu
     * @param spot
     * @returns {*[]}
     */
    const isShelterSituation = () => {
        if(spot.shelterStartTimestamp == null){
            return <dd>閉鎖中</dd>
        }else if(spot.shelterEndTimestamp == null || spot.shelterEndTimestamp == ""){
            return <dd>開設中</dd>
        }else{
            return <dd>閉鎖中</dd>
        }
    }

    const handleSpotData = (menu, spot) => {

        let ret = []

      // 道路に関する情報 本日の規制(01)、今後の規制(02)の場合true
      const isRoad01or02 = option ? ["dorokisei_1", "dorokisei_2"].includes(option.id) : false;

      // 道路に関する情報 事前通行規制区間(03)のマーカーの場合true
      const isRoad03 = option ? ["dorokisei_3"].includes(option.id) : false;
      

      if (menu === 'ボーリングデータ') {

            ret.push(<>
                <dl className='dl-list is-modal-spot'><dt>緯度</dt><dd>{spot.latitude}</dd></dl>
                    <dl className='dl-list is-modal-spot'><dt>経度</dt><dd>{spot.longitude}</dd></dl>
                </>
            )
            
            // file_list部分はリストになっている。
            spot.file_list.map(resource => {
                ret.push(
                  <>
                      <dl className='dl-list is-modal-spot'><dt>{resource.extension.toUpperCase()}</dt><dd><a target="_blank" class="modal-link" href={resource.url}>{resource.name}</a></dd></dl>
                  </>
                )
            })

        } else if (menu === 'ため池ポイント') {

            ret.push(
              <>
                  <dl className='dl-list is-modal-spot'><dt>ため池番号</dt><dd>{spot['ため池番号']}</dd></dl>
                  <dl className='dl-list is-modal-spot'><dt>ため池名称</dt><dd>{spot['ため池名称']}</dd></dl>
                <dl className='dl-list is-modal-spot'><dt>特定農業用ため池の指定年月日</dt><dd>{spot['特定農業用ため池の指定']}</dd></dl>
                  <dl className='dl-list is-modal-spot'><dt>緯度</dt><dd>{spot['緯度']}</dd></dl>
                  <dl className='dl-list is-modal-spot'><dt>経度</dt><dd>{spot['経度']}</dd></dl>
                <dl className='dl-list is-modal-spot'><dt>堤高(m)</dt><dd>{spot['堤高（m）']}</dd></dl>
                <dl className='dl-list is-modal-spot'><dt>総貯水量(千m3)</dt><dd>{spot['貯水量（千m3）']}</dd></dl>

              </>
            )

            // file_list部分はURLのリストになっている。
            spot.file_list.map(fileUrl => {
                ret.push(
                  <>
                      <dl className='dl-list is-modal-spot'><dt>PDF</dt><dd><a target="_blank" className="modal-link" href={fileUrl}>{fileUrl.split('/').pop()}</a></dd></dl>
                  </>
                )
            })

        } else if (menu === '避難所情報'){

            ret.push(
                <>
                    <dl className='dl-list is-modal-spot'><dt>施設名</dt><dd>{spot.name}</dd></dl>
                    <dl className='dl-list is-modal-spot'><dt>住所</dt><dd>{spot.address01 + spot.address02}</dd></dl>
                    <dl className='dl-list is-modal-spot'><dt>緯度</dt><dd>{spot.latitude}</dd></dl>
                    <dl className='dl-list is-modal-spot'><dt>経度</dt><dd>{spot.longitude}</dd></dl>
                    {spot.floodShFlg=='1' && <dl className='dl-list is-modal-spot'><dt>災害種別</dt><dd>洪水</dd></dl>}
                    {spot.sedimentDisasterShFlg=='1' && <dl className='dl-list is-modal-spot'><dt>災害種別</dt><dd>土砂</dd></dl>}
                    {spot.stormSurgeShFlg=='1' && <dl className='dl-list is-modal-spot'><dt>災害種別</dt><dd>高潮</dd></dl>}
                    {spot.earthquakeShFlg=='1' && <dl className='dl-list is-modal-spot'><dt>災害種別</dt><dd>地震</dd></dl>}
                    {spot.tsunamiShFlg=='1' && <dl className='dl-list is-modal-spot'><dt>災害種別</dt><dd>津波</dd></dl>}
                    <dl className='dl-list is-modal-spot'>
                        <dt>開設状況</dt>
                        {isShelterSituation()}
                    </dl>
                </>
                )
        } else if (isRoad01or02){

            ret.push(
                <>
                    <dl className='dl-list is-modal-spot' data-icon={spot.icon}><dt>路線名</dt><dd>{spot.rosenname}</dd></dl>
                    <dl className='dl-list is-modal-spot'><dt>上下線</dt><dd>{spot.updown}</dd></dl>
                    <dl className='dl-list is-modal-spot'><dt>規制内容</dt><dd>{spot.kiseinaiyo}</dd></dl>
                    <dl className='dl-list is-modal-spot'><dt>規制詳細</dt><dd>{spot.kiseisyousai}</dd></dl>
                    <dl className='dl-list is-modal-spot'><dt>規制理由</dt><dd>{spot.kiseireason}</dd></dl>
                    <dl className='dl-list is-modal-spot'><dt>規制開始日</dt><dd>{spot.start_date}</dd></dl>
                    <dl className='dl-list is-modal-spot'><dt>終了予定日</dt><dd>{spot.end_date}</dd></dl>
                    <dl className='dl-list is-modal-spot'><dt>規制時間</dt><dd>{spot.kisei_hour}</dd></dl>
                    <dl className='dl-list is-modal-spot'><dt>規制延長</dt><dd>{spot.encho}</dd></dl>
                    <dl className='dl-list is-modal-spot'><dt>開始地点</dt><dd>{spot.start_point}</dd></dl>
                    <dl className='dl-list is-modal-spot'><dt>終了地点</dt><dd>{spot.end_point}</dd></dl>
                    <dl className='dl-list is-modal-spot'><dt>緯度・経度</dt><dd>北緯{spot.lat}度、東経{spot.lon}度</dd></dl>
                    <dl className='dl-list is-modal-spot'><dt>迂回路有無</dt><dd>{spot.ukairo}</dd></dl>
                    <dl className='dl-list is-modal-spot'><dt>管轄</dt><dd>{spot.demarcation}</dd></dl>
                </>
                )
        
        } else if (isRoad03){

            ret.push(
                <>
                    <dl className='dl-list is-modal-spot' data-icon={spot.icon}><dt>路線名</dt><dd>{spot.rosenname}</dd></dl>
                    <dl className='dl-list is-modal-spot'><dt>開始地点</dt><dd>{spot.kisei_start}</dd></dl>
                    <dl className='dl-list is-modal-spot'><dt>終了地点</dt><dd>{spot.kisei_end}</dd></dl>
                    <dl className='dl-list is-modal-spot'><dt>規制基準</dt><dd>{spot.basis}</dd></dl>
                    <dl className='dl-list is-modal-spot'><dt>危険内容</dt><dd>{spot.kiseinaiyo}</dd></dl>
                    <dl className='dl-list is-modal-spot'><dt>迂回路有無</dt><dd>{spot.ukaiumu}</dd></dl>
                    <dl className='dl-list is-modal-spot'><dt>管轄</dt><dd>{spot.demarcation}</dd></dl>
                </>
                )
        
        } else if (menu === '道路カメラ・冬季道路情報'){

            ret.push(
                <>
                    {(spot["ファイル名"] != '') ?
                        (<dl className='dl-list is-modal-spot'>
                            <dt>{spot["種別"]}</dt>
                            <img src={process.env.REACT_APP_SNOW_BASE_URL+spot["ファイル名"]+"&"+Math.random().toString(32).substring(2)+"="+Math.random().toString(32).substring(2)} 
                                alt={spot["ファイル名"]} 
                                width="240"/>
                        </dl>) : (<></>)}
                    <dl className='dl-list is-modal-spot'><dt>観測地点ID</dt><dd>{spot["観測地点ID"]}</dd></dl>
                    <dl className='dl-list is-modal-spot'><dt>種別</dt><dd>{spot["種別"]}</dd></dl>
                    <dl className='dl-list is-modal-spot'><dt>路線名</dt><dd>{spot["路線名"]}</dd></dl>
                    <dl className='dl-list is-modal-spot'><dt>路線番号</dt><dd>{spot["路線番号"]}</dd></dl>
                    <dl className='dl-list is-modal-spot'><dt>観測施設名</dt><dd>{spot["観測施設名"]}</dd></dl>
                    <dl className='dl-list is-modal-spot'><dt>設置場所</dt><dd>{spot["設置場所"]}</dd></dl>
                    <dl className='dl-list is-modal-spot'><dt>観測日時</dt><dd>{spot["観測日"]+" "+spot["観測時間"]}</dd></dl>
                    <dl className='dl-list is-modal-spot'><dt>道路周辺の積雪深(cm)</dt><dd>{spot["積雪"]}</dd></dl>
                    <dl className='dl-list is-modal-spot'><dt>路面の圧雪深(cm)</dt><dd>{spot["圧雪"]}</dd></dl>
                    <dl className='dl-list is-modal-spot'><dt>気温(℃)</dt><dd>{spot["気温"]}</dd></dl>
                    <dl className='dl-list is-modal-spot'><dt>路面温度(℃)</dt><dd>{spot["路温"]}</dd></dl>
                    <dl className='dl-list is-modal-spot'><dt>路面状態</dt><dd>{spot["路面状態"]}</dd></dl>
                </>
                )

        } else if (menu === '土砂災害情報'){
            Object.entries(spot).map(entry => {
                // 配列があると落ちるので念の為チェック
                if ( ! Array.isArray(entry[1]) && entry[1] != "") {
                    if (entry[0] != '﻿ファイルID' && entry[0] != '地域情報ID' && entry[0] != '撮影位置図ファイルパス' && entry[0] != 'サムネイルパス') {
                        if(entry[0] == '資料ファイルパス') {
                            ret.unshift(<dl className='dl-list is-modal-spot'><dt>写真</dt><img src={entry[1]} alt={entry[0]} width="240"/></dl>)
                        } else {
                            if(entry[0] != '撮影者')ret.push(<dl className='dl-list is-modal-spot'><dt>{entry[0]}</dt><dd>{entry[1]}</dd></dl>)
                        }
                    }
                }
            })
        } else {
            Object.entries(spot).map(entry => {
                // 配列があると落ちるので念の為チェック
                if ( ! Array.isArray(entry[1])) {
                  if (entry[0] != 'GIS情報') {
                    if (menu == '外郭施設（港湾）' || 
                        menu == '係留施設（港湾）' || 
                        menu == '臨港交通施設（港湾）' || 
                        menu == '外郭施設（漁港）'|| 
                        menu == '係留施設（漁港）'|| 
                        menu == '臨港交通施設（漁港）' ||
                        menu == '防潮扉（水門・陸閘）'||
                        menu == '海岸保全施設'){

                        if(entry[0] != "﻿事業" && 
                        entry[0] != "市区町村1" && 
                        entry[0] != "市区町村2" && 
                        entry[0] != "市区町村" && 
                        entry[0] != "防潮扉ID"){
                            if(entry[0] == '開始位置緯度'){
                                ret.push(<dl className='dl-list is-modal-spot'><dt>緯度</dt><dd>{entry[1]}</dd></dl>)
                            } else if(entry[0] == '開始位置経度'){
                                ret.push(<dl className='dl-list is-modal-spot'><dt>経度</dt><dd>{entry[1]}</dd></dl>)
                            } else {
                                ret.push(<dl className='dl-list is-modal-spot'><dt>{entry[0]}</dt><dd>{entry[1]}</dd></dl>)
                            }
                        } 
                        
                    } else {
                      
                        // 全体で共通として不要なメニューは消す。
                        if ( ! ["OBJID",'"OBJID"', "点検対象", "﻿点検対象"].includes(entry[0])) {
                          ret.push(<dl className='dl-list is-modal-spot'><dt>{entry[0]}</dt><dd>{/^https?:\/\//.test(entry[1]) ? <a href={entry[1]} target="_blank" rel="noopener noreferrer">{entry[1]}</a> : entry[1]}</dd></dl>)

                        }
                        
                    }
                  }
                }
            })
        }
        
        return ret
        
    }

    const VectorLayers = ({data, color}) => {
        const roots = data.split("@@")
        // console.log(roots)
        return roots.map(root => {
            const root_split = root.split(" ")
            const type = root_split.shift()
            const str = root_split.join(" ")

            let coords, coords_array, positions  
            switch (type) {
                case "LINESTRING":
                    coords = str.replace("(", "").replace(")", "").split(", ")
                    positions = coords.filter(coord => L.latLng(coord.split(" "))).map(coord => coord.split(" ").reverse())
                    return <Polyline positions={positions} pathOptions={{color:color}}/>
              case "MULTILINESTRING":
                    let index
                    let coords_str = []
                    let next_str = str.slice(1, -1)
                
                    /*
                     * ),を見つけて分割する処理。正規表現でやると後読みを使うとシンプルに記述できるが、safari, iphoneで表示できないので使用禁止。
                     * 
                     * ),を見つけるとその位置で分割したものをcoods_strに保持し、残りをnext_strに代入する。
                     * なのでループは繰り返される。
                     */
                
                    while(next_str.indexOf("),") !== -1){
                        index = next_str.indexOf("),")
                        coords_str.push(next_str.slice(0, index+1))
                        next_str = next_str.slice(index+3)
                    }
                    
                    coords_str.push(next_str)

                    // console.log("後読み", str.slice(1, -1).split(/(?<=\)), /))
                    // console.log(JSON.stringify(coords_str) == JSON.stringify(str.slice(1, -1).split(/(?<=\)), /)))

                    coords_array = coords_str.map(s => s.replace("(", "").replace(")", "").split(", "))
                    positions = coords_array.map(coords => coords.filter(coord => L.latLng(coord.split(" "))).map(coord => coord.split(" ").reverse()))    
                    return <Polyline positions={positions} pathOptions={{color:color}}/> 
                case "POLYGON":

                  /**
                   * ),を見つけて分割する処理。正規表現でやると後読みを使うとシンプルに記述できるが、safari, iphoneで表示できないので使用禁止。
                   * 
                   * ),を見つけるとその位置で分割したものをcoods_strに保持し、残りをnext_strに代入する。
                   * なのでループは繰り返される。
                   */
                  const handlePolygon = (str) => {
                    let index
                    const coords_str = []

                    // 両端の括弧を取り除く
                    let next_str = str.slice(1, -1)

                    // 1つでも),が含まれているかどうかで処理を分岐
                    if (next_str.indexOf("),") !== -1) {

                      while(next_str.indexOf("),") !== -1){
                        index = next_str.indexOf("),")
                        coords_str.push(next_str.slice(0, index+1))
                        next_str = next_str.slice(index+3)
                      }

                      coords_str.push(next_str)
                      
                    } else {

                      // そもそも ),が含まれていない場合
                      coords_str.push(next_str)
                    }

                    coords_array = coords_str.map(s => s.replace("(", "").replace(")", "").split(", "))
                    positions = coords_array.map(coords => coords.filter(coord => L.latLng(coord.split(" "))).map(coord => coord.split(" ").reverse()))

                    return positions
                  }
                  
                  const polygonPositions = handlePolygon(str)
                  
                  return <Polygon positions={polygonPositions} pathOptions={{color:color}}/>
                
              case "MULTIPOLYGON":  
                
                const handleMultiPolygon = (str) => {
                  let index
                  const coords_str = []

                  // 両端の括弧を取り除く
                  let next_str = str.slice(1, -1)

                  // 1つでも),が含まれているかどうかで処理を分岐
                  if (next_str.indexOf("),") !== -1) {

                    while(next_str.indexOf("),") !== -1){

                      index = next_str.indexOf("),")
                      coords_str.push(next_str.slice(0, index+1))
                      next_str = next_str.slice(index+3)
                    }

                    coords_str.push(next_str)

                  } else {
                    
                    coords_str.push(next_str)
                  }

                  // さらにネストした子要素を),で分割
                  const coords_str2 = coords_str.map(sub_str => {

                    let sub_index
                    const sub_coords_str = []

                    // 両端の括弧を取り除く
                    let sub_next_str = sub_str.slice(1, -1)
                    
                    // 1つでも),が含まれているかどうかで処理を分岐
                    if (sub_next_str.indexOf("),") !== -1) {

                      while(sub_next_str.indexOf("),") !== -1){

                        sub_index = sub_next_str.indexOf("),")
                        sub_coords_str.push(sub_next_str.slice(0, sub_index+1))
                        sub_next_str = sub_next_str.slice(sub_index+3)
                      }

                      sub_coords_str.push(sub_next_str)

                    } else {

                      sub_coords_str.push(sub_next_str)
                    }
                    
                    return sub_coords_str
                  })
                  
                  let coords_array = coords_str2.map(
                    s => s.map(s => s.replace("(", "").replace(")", "").split(", "))
                  )

                  const positions = coords_array.map(coords => coords.map(coord => coord.filter(c => L.latLng(c.split(" "))).map(c => c.split(" ").reverse())))

                  return positions
                }
                
                const multiPolygonPositions = handleMultiPolygon(str)
                
                    return <Polygon positions={multiPolygonPositions} pathOptions={{color:color}}/> 
                default:
                    return null
            }
        })
    }
    
    if(latitude > minlat && latitude < maxlat && longitude > minlng && longitude < maxlng){

        return (
            <>
                <Marker 
                    position={[latitude, longitude]} 
                    icon={iconUrl} 
                >
                    <Popup autoPan={false}  minHeight={300} maxHeight={400} minWidth={500} closeOnClick>
                        {
                            handleSpotData(menu, spot)
                        }
                    </Popup>
                </Marker>       
                
                {/* 本日の規制、今後の規制の場合の線ポリゴンの表示 */}
                {(option 
                    && ["dorokisei_1", "dorokisei_2"].includes(option.id)) 
                    && (spot.kukanroot!=null || spot.ukairoot!=null) 
                    && <>
                        {spot.kukanroot && <VectorLayers data={spot.kukanroot} color="red"/>}
                        {spot.ukairoot && <VectorLayers data={spot.ukairoot} color="green"/>}
                       </>}
                
                {option
                    && ["03"].includes(option.id)
                    && (spot.kukanroot!=null || spot.kukan!=null) 
                    && <>
                        {spot.kukanroot && <VectorLayers data={spot.kukanroot} color="red"/>}
                        {spot.kukan && <VectorLayers data={spot.kukan} color="red"/>}
                       </>}

                {(menu=="外郭施設（港湾）" || menu=="係留施設（港湾）" || menu=="臨港交通施設（港湾）" || menu=="海岸施設" || menu=="係留施設（漁港）" || menu=="外郭施設（漁港）" || menu=="臨港交通施設（漁港）" || menu=="海岸保全施設" ) 
                    && spot["GIS情報"]!=null
                    && <VectorLayers data={spot["GIS情報"]} color="red"/>
                }
                    
            </>  
        );
    }else{
        return null
    }
}

export default Component;
